// import { Injectable, inject } from '@angular/core';
// import { CanActivate, Router } from '@angular/router';
// import { MockAuthService } from '../services/mock-auth.service';
//
// @Injectable({ providedIn: 'root' })
// export class RoleGuard implements CanActivate {
//   private auth = inject(MockAuthService);
//   private router = inject(Router);
//
//   canActivate(route: any): boolean {
//     const expectedRole = route.data['role'];
//     const actualRole = this.auth.getRole();
//
//     if (this.auth.isAuthenticated() && expectedRole === actualRole) {
//       return true;
//     }
//
//     // Redirect to landing page or login
//     this.router.navigate(['/']);
//     return false;
//   }
// }
import { AuthGuardData, createAuthGuard } from 'keycloak-angular'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { inject } from '@angular/core'

const isAccessAllowed = async (
	route: ActivatedRouteSnapshot,
	__: RouterStateSnapshot,
	authData: AuthGuardData
): Promise<boolean | UrlTree> => {
	const { authenticated, grantedRoles } = authData

	// Support both a single role (data['role']) and an array (data['roles']).
	const requiredRoles: string[] = Array.isArray(route.data['roles'])
		? route.data['roles']
		: route.data['role']
			? [route.data['role']]
			: []
	if (requiredRoles.length === 0 || requiredRoles.includes('')) {
		// No role restriction declared — fall back to plain authentication.
		return authenticated ? true : inject(Router).parseUrl('/')
	}

	const hasAnyRequiredRole = (role: string): boolean =>
		Object.values(grantedRoles.realmRoles).some(roles => roles.includes(role))

	if (authenticated && requiredRoles.some(hasAnyRequiredRole)) {
		return true
	}

	const router = inject(Router)
	return router.parseUrl('/')
}

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed)
